// @flow
import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../services/apiService/apiService';

export const createOaModalActions = {
  SHOW_CREATE_OA_MODAL: 'SHOW_CREATE_OA_MODAL',
  CREATE_OA_SUBMIT: 'CREATE_OA_SUBMIT',
  CREATE_OA: 'CREATE_OA',
  CHECK_OA_MOBILE: 'CHECK_OA_MOBILE'
};

export const showCreateOaModalAction = (data: boolean) => ({
  type: createOaModalActions.SHOW_CREATE_OA_MODAL,
  payload: data
});

export const createOaAction = (data: Object) => ({
  type: createOaModalActions.CREATE_OA,
  payload: data
});

export const onCreateOaSubmitAction = (requestParams: Object) => (
  dispatch: Function
) => {
  // eslint-disable-next-line
  dispatch(
    createOaAction({
      isLoading: true,
      isLoaded: false,
      data: { status: null, val: null }
    })
  );
  const isPull = requestParams.isPullFlag;
  let requestMethod = 'POST';
  let apiEndPoint = 'oaGetCreate';
  const data = requestParams.user;
  let pathVariables = [];
  if (isPull) {
    requestMethod = 'PUT';
    apiEndPoint = 'oaPullAtOu';
    pathVariables = [{ key: '{userId}', val: requestParams.userId }];
  }

  const successMsg = (isPullFlag, res) => {
    if (isPullFlag) {
      return `OA with name: ${res.payload.name} updated successfully`;
    }
    return `OA with name: ${res.payload.name} created successfully`;
  };

  const requestObj = {
    apiEndPoint,
    baseUrl: 'zoomApiUrl',
    method: requestMethod,
    data,
    pathVariables,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          createOaAction({
            isLoading: false,
            isLoaded: true,
            data: {
              status: 'success',
              val: successMsg(isPull, res)
            }
          })
        );
      } else {
        dispatch(
          createOaAction({
            isLoading: false,
            isLoaded: false,
            data: {
              status: 'error',
              val: res.errorMessage || 'Could not create OA'
            }
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        createOaAction({
          isLoading: false,
          isLoaded: false,
          data: {
            status: 'error',
            val: res.errorMessage || 'Could not create OA'
          }
        })
      );
    },
    catchCb: () => {
      dispatch(
        createOaAction({
          isLoading: false,
          isLoaded: false,
          data: { status: 'exception', val: 'Could not create OA' }
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const checkOaMobile = (data: Object) => ({
  type: createOaModalActions.CHECK_OA_MOBILE,
  payload: data
});

export const checkOaMobileExistsAction = mobileNo => (dispatch: Function) => {
  if (mobileNo.length !== 10) {
    return null;
  }
  // eslint-disable-next-line
  dispatch(
    checkOaMobile({
      oaMobile: {
        isLoading: true,
        isLoaded: false,
        data: { status: null, val: null }
      }
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'checkOaMobile',
    pathVariables: [{ key: '{mobile}', val: mobileNo }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          checkOaMobile({
            oaMobile: {
              isLoading: false,
              isLoaded: true,
              data: {
                status: 'success',
                val: res.payload
              }
            }
          })
        );
      } else {
        dispatch(
          checkOaMobile({
            isLoading: false,
            isLoaded: false,
            data: {
              status: 'error',
              val: res.errorMessage || 'Could not check OA mobile no'
            },
            oaMobile: {
              isLoading: false,
              isLoaded: true,
              data: {
                status: 'error',
                val: res.errorMessage || 'Could not check OA mobile no'
              }
            }
          })
        );
      }
    },
    failureCb: () => {
      dispatch(
        checkOaMobile({
          oaMobile: {
            isLoading: false,
            isLoaded: false,
            data: {
              status: 'error',
              val: ''
            }
          }
        })
      );
    },
    catchCb: () => {
      dispatch(
        checkOaMobile({
          oaMobile: {
            isLoading: false,
            isLoaded: false,
            data: {
              status: 'error',
              val: ''
            }
          }
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const fetchVendorOptions = setOptions => {
  const requestObj = {
    baseUrl: 'vendorContractUrl',
    apiEndPoint: 'getActiveFaujiVendor',
    successCb: res => {
      const options =
        res.response &&
        res.response.map(option => ({
          value: option.vendorCode,
          label: `${option.vendorName}(${option.vendorCode})`,
          vendorName: option.vendorName
        }));
      setOptions(options);
    },
    failureCb: () => {
      toastr.error('Something went wrong!', 'Unable to fetch vendors.');
    },
    catchCb: () => {
      toastr.error('Something went wrong!', 'Unable to fetch vendors.');
    }
  };
  makeApiCall(requestObj);
};
